import { AttachmentDeltaPositionFilter } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { AttributeBond, FamilyType } from "./attacher-attribute";

type CustomAttachmentDeltaPositionFilter = (
	args: Parameters<AttachmentDeltaPositionFilter>[0] & {
		context: Readonly<AttacherSolverContext>;
	},
) => ReturnType<AttachmentDeltaPositionFilter>;

const check = {
	entitiesAreWithinSnapRange: (args) =>
		args.context.snapRange !== null
			? args.deltaPosition.length() <= args.context.snapRange
			: true,
} as const satisfies Record<string, CustomAttachmentDeltaPositionFilter>;

const defaultAttachmentDeltaPositionFilter: CustomAttachmentDeltaPositionFilter =
	(args) => check.entitiesAreWithinSnapRange(args);

const attachmentDeltaPositionFilterByFamilyBond: AttributeBond<
	FamilyType,
	CustomAttachmentDeltaPositionFilter
> = {} as const;

export function createAttachmentDeltaPositionFilter(
	context: AttacherSolverContext,
): AttachmentDeltaPositionFilter {
	const { attacherAttributeMap } = context;

	return (args) => {
		const fromFamily = attacherAttributeMap.get("family", args.from);
		const toFamily = attacherAttributeMap.get("family", args.to);

		return (
			attachmentDeltaPositionFilterByFamilyBond[fromFamily]?.[toFamily] ??
			defaultAttachmentDeltaPositionFilter
		)({ ...args, context });
	};
}
